'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var conversionConfig_1 = require("./conversionConfig");
var coreUtils_1 = require("coreUtils");
var isMergeVirtualGroup = function (comp) { return _.get(comp, 'componentType') === conversionConfig_1.conversionConfig.VIRTUAL_GROUP_TYPES.MERGE; };
exports.isMergeVirtualGroup = isMergeVirtualGroup;
var isRescaleVirtualGroup = function (comp) { return _.get(comp, 'componentType') === conversionConfig_1.conversionConfig.VIRTUAL_GROUP_TYPES.RESCALE; };
exports.isRescaleVirtualGroup = isRescaleVirtualGroup;
var isVirtualGroup = function (comp) { return isRescaleVirtualGroup(comp) || isMergeVirtualGroup(comp); };
exports.isVirtualGroup = isVirtualGroup;
function isDesktopOnlyComponent(component) {
    return _.get(component, ['conversionData', 'desktopOnly'], false);
}
exports.isDesktopOnlyComponent = isDesktopOnlyComponent;
function isTextComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'text';
}
exports.isTextComponent = isTextComponent;
function isGraphicComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'graphic' || isImageComponent(component);
}
exports.isGraphicComponent = isGraphicComponent;
function isGroupComponent(component) {
    return component && (component.componentType === 'wysiwyg.viewer.components.Group');
}
exports.isGroupComponent = isGroupComponent;
function isColumnsContainerComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'columns';
}
exports.isColumnsContainerComponent = isColumnsContainerComponent;
function isImageComponent(component) {
    return _.get(component, ['conversionData', 'category']) === 'photo';
}
exports.isImageComponent = isImageComponent;
function isMasterPage(component) {
    return _.get(component, 'id') === 'masterPage';
}
exports.isMasterPage = isMasterPage;
function shouldStretchToScreenWidth(component) {
    var shouldStretchHorizontally = function (comp) {
        return _.get(comp.conversionData, 'isScreenWidth', false) ||
            _.get(comp.conversionData, 'stretchHorizontally', false) ||
            _.some(comp.components, shouldStretchHorizontally);
    };
    return isSiteSegmentOrPage(component) || shouldStretchHorizontally(component);
}
exports.shouldStretchToScreenWidth = shouldStretchToScreenWidth;
function isScreenWidthComponent(component) {
    return _.get(component.conversionData, 'isScreenWidth', false) || _.some(component.components, isScreenWidthComponent);
}
exports.isScreenWidthComponent = isScreenWidthComponent;
function translateComps(comps, x, y) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    _.forEach(comps, function (comp) {
        comp.layout.x += x;
        comp.layout.y += y;
    });
}
exports.translateComps = translateComps;
function reparentComponent(parent, newChild, index) {
    addComponentsTo(parent, [newChild], index);
    translateComps([newChild], -parent.layout.x, -parent.layout.y);
}
exports.reparentComponent = reparentComponent;
function addComponentsTo(container, components, index) {
    var children = getChildren(container);
    if (!components.length || !children) {
        return;
    }
    index = index !== undefined ? index : children.length;
    children.splice.apply(children, [index, 0].concat(components));
}
exports.addComponentsTo = addComponentsTo;
function removeChildrenFrom(container, componentsToRemove) {
    var children = getChildren(container);
    _.remove(children, function (child) { return _.includes(componentsToRemove, child); });
}
exports.removeChildrenFrom = removeChildrenFrom;
function removeGroup(group, groupParent) {
    if (!isGroupComponent(group)) {
        return;
    }
    var groupIndex = _.findIndex(groupParent.components, { id: group.id });
    _.forEach(group.components.reverse(), function (curGroupedComponent) {
        addComponentsTo(groupParent, [curGroupedComponent], groupIndex);
        translateComps([curGroupedComponent], group.layout.x, group.layout.y);
    });
    _.remove(groupParent.components, group);
}
exports.removeGroup = removeGroup;
function containsComponent(container, componentMatcher) {
    return _.some(getChildren(container), function (child) { return componentMatcher(child) || child && containsComponent(child, componentMatcher); });
}
exports.containsComponent = containsComponent;
function getHeightAccordingToChildren(container, children, enforceShrinkEvenWithNoChildren) {
    if (isMasterPage(container)) {
        return;
    }
    if (!children || (!enforceShrinkEvenWithNoChildren && _.isEmpty(children))) {
        return;
    }
    var lowestChildBottom = _(children)
        .reject(['conversionData.isInvisible', true])
        .reduce(function (lowest, child) { return _.max([lowest, child.layout.y + child.layout.height, 0]); }, 0);
    if (_.get(container, ['conversionData', 'hasTightYMargin']) || _.get(container, ['conversionData', 'hasTightBottomMargin'])) {
        return lowestChildBottom;
    }
    var bottomMargin = shouldStretchToScreenWidth(container) ? conversionConfig_1.conversionConfig.SECTION_MOBILE_MARGIN_Y : conversionConfig_1.conversionConfig.COMPONENT_MOBILE_MARGIN_Y + _.get(container.conversionData, 'borderWidth', 0);
    return lowestChildBottom + bottomMargin;
}
exports.getHeightAccordingToChildren = getHeightAccordingToChildren;
function ensureContainerTightlyWrapsChildren(container, children, enforceShrinkEvenWithNoChildren, defaultMinHeight) {
    if (defaultMinHeight === void 0) { defaultMinHeight = 0; }
    var heightByChildren = getHeightAccordingToChildren(container, children, enforceShrinkEvenWithNoChildren);
    if (_.isNumber(heightByChildren)) {
        var minHeight = _.get(container, ['conversionData', 'minHeight'], defaultMinHeight);
        container.layout.height = Math.max(minHeight, heightByChildren);
    }
}
exports.ensureContainerTightlyWrapsChildren = ensureContainerTightlyWrapsChildren;
function isSiteSegmentOrPage(component) {
    return isPageComponent(component) || isSiteSegment(component);
}
exports.isSiteSegmentOrPage = isSiteSegmentOrPage;
function isPageComponent(component) {
    return component.type === 'Page';
}
exports.isPageComponent = isPageComponent;
function isContainerComponent(component) {
    return component.type === 'Container';
}
exports.isContainerComponent = isContainerComponent;
function isSiteSegment(component) {
    return _.has(component.conversionData, 'siteSegmentRole');
}
exports.isSiteSegment = isSiteSegment;
function extractMobilePage(desktopPage) {
    var mobilePage = coreUtils_1.objectUtils.cloneDeep(desktopPage);
    var childrenPropertyName = _.has(mobilePage, 'components') ? 'components' : 'children';
    return _.set(mobilePage, childrenPropertyName, desktopPage.mobileComponents || []);
}
exports.extractMobilePage = extractMobilePage;
function getComponentByIdFromStructure(componentId, component) {
    if (component.id === componentId) {
        return component;
    }
    var res = null;
    _.find(getChildren(component), function (comp) {
        res = getComponentByIdFromStructure(componentId, comp);
        return res;
    });
    return res;
}
exports.getComponentByIdFromStructure = getComponentByIdFromStructure;
function unifyGroups(groups, groupOverflowThreshold) {
    if (groups.length > groupOverflowThreshold) {
        groups.length = 0;
        return;
    }
    var haveCommonElements = function (arr1, arr2) { return _.size(_.intersection(arr1, arr2)) > 0; };
    var _loop_1 = function (i) {
        var j = _.findLastIndex(groups, function (group, index) { return index < i && haveCommonElements(groups[i], group); });
        if (j !== -1) {
            groups[j] = groups[j].concat(_.difference(groups[i], groups[j]));
            groups.splice(i, 1);
        }
    };
    for (var i = groups.length - 1; i >= 0; i--) {
        _loop_1(i);
    }
}
exports.unifyGroups = unifyGroups;
function getComponentsByIds(container, compIds) {
    var children = getChildren(container);
    return _.map(compIds, function (id) { return _.find(children, { id: id }) || null; });
}
exports.getComponentsByIds = getComponentsByIds;
function getParent(componentId, root) {
    var children = getChildren(root);
    if (_.find(children, { id: componentId })) {
        return root;
    }
    var parent = null;
    _.find(children, function (child) {
        parent = getParent(componentId, child);
        return parent;
    });
    return parent;
}
exports.getParent = getParent;
function getSnugLayout(components) {
    if (!components || components.length === 0) {
        return undefined;
    }
    var mostLeft = _.min(_.map(components, 'layout.x'));
    var mostTop = _.min(_.map(components, 'layout.y'));
    var mostRight = _.max(_.map(components, function (c) { return c.layout.x + c.layout.width; }));
    var mostBottom = _.max(_.map(components, function (c) { return c.layout.y + c.layout.height; }));
    return {
        x: mostLeft,
        y: mostTop,
        width: mostRight - mostLeft,
        height: mostBottom - mostTop,
        rotationInDegrees: 0
    };
}
exports.getSnugLayout = getSnugLayout;
function getTinyMenuDefaultPosition() {
    return {
        x: conversionConfig_1.conversionConfig.MOBILE_WIDTH - (conversionConfig_1.conversionConfig.TINY_MENU_SIZE + conversionConfig_1.conversionConfig.SITE_SEGMENT_PADDING_X),
        y: conversionConfig_1.conversionConfig.SECTION_MOBILE_MARGIN_Y,
        rotationInDegrees: 0
    };
}
exports.getTinyMenuDefaultPosition = getTinyMenuDefaultPosition;
function getChildren(comp) {
    return comp.components || comp.children;
}
exports.getChildren = getChildren;
function getRangesOverlap(range1, range2) {
    if (range1 === void 0) { range1 = []; }
    if (range2 === void 0) { range2 = []; }
    var getSortedRangesOverlap = function (r1, r2) { return Math.min(r1[1], r2[1]) - r2[0]; };
    return range1[0] <= range2[0] ? getSortedRangesOverlap(range1, range2) : getSortedRangesOverlap(range2, range1);
}
exports.getRangesOverlap = getRangesOverlap;
function getYOverlap(comp1, comp2) {
    var getYProjection = function (comp) { return [comp.layout.y, comp.layout.height + comp.layout.y]; };
    return getRangesOverlap(getYProjection(comp1), getYProjection(comp2));
}
exports.getYOverlap = getYOverlap;
function getXOverlap(comp1, comp2) {
    if (isScreenWidthComponent(comp1)) {
        return comp2.layout.width;
    }
    if (isScreenWidthComponent(comp2)) {
        return comp1.layout.width;
    }
    var getXProjection = function (comp) { return [comp.layout.x, comp.layout.width + comp.layout.x]; };
    return getRangesOverlap(getXProjection(comp1), getXProjection(comp2));
}
exports.getXOverlap = getXOverlap;
var getArea = function (component) { return component.layout.width * component.layout.height; };
function hasGreaterArea(comp1, comp2) {
    if (isScreenWidthComponent(comp1)) {
        return comp1.layout.height >= comp2.layout.height || getArea(comp1) > getArea(comp2);
    }
    if (isScreenWidthComponent(comp2)) {
        return false;
    }
    return getArea(comp1) > getArea(comp2);
}
exports.hasGreaterArea = hasGreaterArea;
function haveSufficientOverlap(comp1, comp2, overlapToMinAreaRationThreshold) {
    var xOverlap = getXOverlap(comp1, comp2);
    var yOverlap = getYOverlap(comp1, comp2);
    if (xOverlap <= 0 || yOverlap <= 0) {
        return false;
    }
    var overlapArea = xOverlap * yOverlap;
    var minCompArea = Math.min(getArea(comp1), getArea(comp2));
    return overlapArea > 0 && overlapArea / minCompArea >= overlapToMinAreaRationThreshold;
}
exports.haveSufficientOverlap = haveSufficientOverlap;
function isEmptyContainer(component) {
    if (!isContainerComponent(component)) {
        return false;
    }
    if (component.conversionData.category === 'columns') {
        return _.size(component.components) === 1 && _.isEmpty(component.components[0].components);
    }
    return _.isEmpty(component.components);
}
exports.isEmptyContainer = isEmptyContainer;
function shouldReparentCompToChildOfContainer(comp, container) {
    return isColumnsContainerComponent(container) && _.get(comp, ['conversionData', 'isInvisible'], false);
}
exports.shouldReparentCompToChildOfContainer = shouldReparentCompToChildOfContainer;
function getAllCompsInStructure(compStructure, isMobile, filterFunc) {
    if (isMobile === void 0) { isMobile = false; }
    var queue = [[compStructure]];
    for (var index = 0; index < queue.length; index++) {
        var innerQueue = queue[index];
        _.forEach(innerQueue, function (child) {
            var children = isMobile ? _.get(child, 'mobileComponents') : getChildren(child);
            if (!_.isEmpty(children)) {
                queue.push(children);
            }
        });
    }
    return _(queue).flatten().remove(filterFunc).keyBy('id').value();
}
exports.getAllCompsInStructure = getAllCompsInStructure;



//////////////////
// WEBPACK FOOTER
// ./src/mobileCore/main/conversionUtils.ts
// module id = 1
// module chunks = 0 1